export default __webpack_public_path__ + "static/media/chevron_down.6a2476f5.svg";